import type { PayloadAction } from "@reduxjs/toolkit";
import { DateFormat, TimeFormat, TimezoneDst } from "Data/Objects/System";
import { createAppSlice } from "Data/Redux/Store";
import type { DateTimeSettingsState } from "Interfaces";

const initialState: DateTimeSettingsState = {
	dateTimeSetup: {
		dateTime: 0,
		dateFormat: DateFormat.MM_DD_YYYY,
		timeFormat: TimeFormat.TWENTYFOUR_HOUR
	},
	networkTimeServerSetup: {
		timeServer: "pool.ntp.org",
		autoTimeSync: false,
		syncTime: "00:00"
	},
	timezoneDstSetup: {
		timezoneDst: TimezoneDst.T6,
		dst: true
	}
};

export const setDateTimeReducer = (
	state: DateTimeSettingsState,
	action: PayloadAction<DateTimeSettingsState>
) => {
	return action.payload;
};

export const getDateTime = (state: DateTimeSettingsState) => {
	return state;
};

const dateTimeSlice = createAppSlice({
	name: "datetime",
	initialState,
	reducers: {
		setDateTimeAction: setDateTimeReducer
	},
	selectors: {
		selectDateTime: getDateTime
	}
});

export default dateTimeSlice;

export const { setDateTimeAction } = dateTimeSlice.actions;
export const { selectDateTime } = dateTimeSlice.selectors;
